// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/Icons/filter_up_icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Assets/Icons/filter_dropicon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpeciesGroup{
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);
    border-radius: 8px;
    height: 78vh;
    overflow: auto;
}

.Card {
    width: 100%;
    padding: 32px;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);
    border-radius: 8px;
}

.Top_Card{
    height: 500px;
    overflow: auto;
}

.Top_Card::-webkit-scrollbar {
    width: 6px;
    height: 72px;
}

::-webkit-scrollbar-thumb {
    background: #D9D9D9;
    border-radius: 10px;
}



.recent_popup-content{
    width: 80% !important;
    padding: 0;
}


.Card_Heading {
    display: flex;
    justify-content: space-between;
}

.datepicker-container {
    border: none;
    width: fit-content;
    background-color: #FAF5F0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right center;
    cursor: pointer;
}
.datepicker-container:focus-visible{
    outline: none;
    border: none;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-position: right center;
    cursor: pointer;
}

.stat_element {
    width: 20%;
    height: 104px;
    background: #FAF5F0;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 24px;
}

.stat_title {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #594F42;

}

.stat_count {
    font-weight: 500;
    font-size: 24px;
    line-height: 29px;
    color: #3F3325;
}

.Stat_Card_Content {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: space-between;
    margin-top: 24px;
}


.Card_title {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
}

.Card_title>span {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #3F3325;

}

.Card_Link>span {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #38514C;
    cursor: pointer;
}

.top_element {
    border-radius: 8px;
    width: 200px;
    height: 200px;
    position: relative;
    display: flex;
    flex-direction: column;
}

.top_span {
    padding-top: 10px;
    padding-left: 10px;
    display: flex;
    flex-direction: column;
}

.top_name {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: white;
    z-index: 1;
}

.top_count {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: white;
    z-index: 1;

}

.top_element>img {
    width: 100%;
    position: absolute;
    bottom: 0;
    height: 100%;
    border-radius: 8px;
}

.Top_Card_Content {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    align-items: center;
    justify-content: center;
    margin-top: 24px;
}

.top_tiger {
    margin-top: 20px;
}
.top_tiger_Heading{
    display: flex;
    justify-content: space-between;
    font-size: 0.9rem;
    opacity: 80%;
    color: gray;
    margin-bottom: 10px;
}
.top_tiger_Content{
    max-height: 65vh;
    overflow-y: scroll;
}

.top_tiger_Indi_Content{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.top_tiger_Bar{
    height: 2vh;
    background: #48887b;
    border-radius: 1vw;
    border: solid 5px #dae7e5;
}

.recent_items {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center;
    /* justify-content: space-between; */
}

.recent_items>img {
    width: 232px;
    height: 170px;
    border-radius: 8px;
}

.recent_image {
    display: flex;
    gap: 16px;
    margin-top: 24px;
    align-items: center;
    justify-content: center;
}

.recent_image>img {
    width: 40%;
    height: 352px;
    border-radius: 8px;
}

.unclassified_card_content {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center;
    margin-top: 10px
}

.big_un {
    width: 222px;
    height: 149px;
    border-radius: 8px;
}


.classified_img {
    width: 170px;
    height: 149px;
    border-radius: 8px;
}

.ChartXaxis {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    width: 5%;
    justify-content: center;
}

.ChartXaxis>span {
    display: flex;
    flex-shrink: 0;
    transform: rotate(-90deg);
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #3F3325;
}


.toggle_label {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 30px;
}

.toggle_input {
    opacity: 0;
    width: 0;
    height: 0;
}

.toggle_span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #E8DFD5;
    transition: 0.3s;
    border-radius: 30px;
}


.toggle_span:before {
    position: absolute;
    content: "";
    height: 25px;
    width: 25px;
    left: 3px;
    bottom: 2.6px;
    background-color: #fff;
    border-radius: 50%;
    transition: 0.3s;
}

.toggle_input:checked+.toggle_span {
    background-color: #48887B;
}

.toggle_input:checked+.toggle_span:before {
    transform: translateX(29px);
}

.ImageCard {
    width: 92%;
    display: flex;
    padding: 5px;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);
    border-radius: 5px;
    margin-left: 60px;
    margin-top: -20px;
}

.image-container {
    flex: 1 1;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.image-container img {
    max-width: 100%;
    max-height: 100%;
    display: block;
    border-radius: 5px;
    object-fit: contain;
}

.arrows-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px; 
  box-sizing: border-box;
}

.left-arrow {
  position: absolute;
  left: 0;
}

.right-arrow {
  position: absolute;
  right: 0;
}
.MatchCard {
    width: 90%;
    display: flex;
    padding: 10px;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);
    border-radius: 5px;
    margin-left: 6px;
}

.RightCard {
    width: 30%; 
    height: 187px;
    padding: 10px;
    background: #FFFFFF;
    margin: auto;
    margin-top: 5px; 
    margin-bottom: auto;
}

.datacard {
  background-color: white;
  border-radius: 8px;
  width: 280px;
  height: 90px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
border: 2px solid #e0e0e0; /* Example border with a light gray color */

}

.cardheader {
  /* border-bottom: 1px solid #ccc; */
  margin-bottom: 10px;
  /* padding-bottom: 10px; */
}

.content {
    margin-top: 0;
}

.cardheader h4 {
  margin: 0;
  font-size: 15px;
  
}

.cardline {
  border: none;
  border-top: 1px solid #ccc;
  margin-top: 3px;
}

.cardicon {
    width: 12%;
    
}
`, "",{"version":3,"sources":["webpack://./src/CSS/Card.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;IACnB,gDAAgD;IAChD,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gDAAgD;IAChD,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;;;AAIA;IACI,qBAAqB;IACrB,UAAU;AACd;;;AAGA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,mDAAqD;IACrD,4BAA4B;IAC5B,iCAAiC;IACjC,eAAe;AACnB;AACA;IACI,aAAa;IACb,YAAY;IACZ,mDAAsD;IACtD,4BAA4B;IAC5B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,8BAA8B;IAC9B,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,UAAU;;AAEd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,gDAAgD;IAChD,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;IACI,UAAU;IACV,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,gDAAgD;IAChD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,wCAAwC;EACxC,aAAa;AACf,yBAAyB,EAAE,2CAA2C;;AAEtE;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;;AAEjB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;IACI,UAAU;;AAEd","sourcesContent":[".SpeciesGroup{\n    width: 100%;\n    background: #FFFFFF;\n    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);\n    border-radius: 8px;\n    height: 78vh;\n    overflow: auto;\n}\n\n.Card {\n    width: 100%;\n    padding: 32px;\n    background: #FFFFFF;\n    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);\n    border-radius: 8px;\n}\n\n.Top_Card{\n    height: 500px;\n    overflow: auto;\n}\n\n.Top_Card::-webkit-scrollbar {\n    width: 6px;\n    height: 72px;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #D9D9D9;\n    border-radius: 10px;\n}\n\n\n\n.recent_popup-content{\n    width: 80% !important;\n    padding: 0;\n}\n\n\n.Card_Heading {\n    display: flex;\n    justify-content: space-between;\n}\n\n.datepicker-container {\n    border: none;\n    width: fit-content;\n    background-color: #FAF5F0;\n    background: url('../Assets/Icons/filter_up_icon.png');\n    background-repeat: no-repeat;\n    background-position: right center;\n    cursor: pointer;\n}\n.datepicker-container:focus-visible{\n    outline: none;\n    border: none;\n    background: url('../Assets/Icons/filter_dropicon.png');\n    background-repeat: no-repeat;\n    background-position: right center;\n    cursor: pointer;\n}\n\n.stat_element {\n    width: 20%;\n    height: 104px;\n    background: #FAF5F0;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    padding: 24px;\n}\n\n.stat_title {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #594F42;\n\n}\n\n.stat_count {\n    font-weight: 500;\n    font-size: 24px;\n    line-height: 29px;\n    color: #3F3325;\n}\n\n.Stat_Card_Content {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    justify-content: space-between;\n    margin-top: 24px;\n}\n\n\n.Card_title {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n}\n\n.Card_title>span {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 24px;\n    color: #3F3325;\n\n}\n\n.Card_Link>span {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #38514C;\n    cursor: pointer;\n}\n\n.top_element {\n    border-radius: 8px;\n    width: 200px;\n    height: 200px;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n}\n\n.top_span {\n    padding-top: 10px;\n    padding-left: 10px;\n    display: flex;\n    flex-direction: column;\n}\n\n.top_name {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 20px;\n    color: white;\n    z-index: 1;\n}\n\n.top_count {\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    color: white;\n    z-index: 1;\n\n}\n\n.top_element>img {\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    height: 100%;\n    border-radius: 8px;\n}\n\n.Top_Card_Content {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    align-items: center;\n    justify-content: center;\n    margin-top: 24px;\n}\n\n.top_tiger {\n    margin-top: 20px;\n}\n.top_tiger_Heading{\n    display: flex;\n    justify-content: space-between;\n    font-size: 0.9rem;\n    opacity: 80%;\n    color: gray;\n    margin-bottom: 10px;\n}\n.top_tiger_Content{\n    max-height: 65vh;\n    overflow-y: scroll;\n}\n\n.top_tiger_Indi_Content{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.top_tiger_Bar{\n    height: 2vh;\n    background: #48887b;\n    border-radius: 1vw;\n    border: solid 5px #dae7e5;\n}\n\n.recent_items {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    justify-content: center;\n    /* justify-content: space-between; */\n}\n\n.recent_items>img {\n    width: 232px;\n    height: 170px;\n    border-radius: 8px;\n}\n\n.recent_image {\n    display: flex;\n    gap: 16px;\n    margin-top: 24px;\n    align-items: center;\n    justify-content: center;\n}\n\n.recent_image>img {\n    width: 40%;\n    height: 352px;\n    border-radius: 8px;\n}\n\n.unclassified_card_content {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    justify-content: center;\n    margin-top: 10px\n}\n\n.big_un {\n    width: 222px;\n    height: 149px;\n    border-radius: 8px;\n}\n\n\n.classified_img {\n    width: 170px;\n    height: 149px;\n    border-radius: 8px;\n}\n\n.ChartXaxis {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    width: 5%;\n    justify-content: center;\n}\n\n.ChartXaxis>span {\n    display: flex;\n    flex-shrink: 0;\n    transform: rotate(-90deg);\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #3F3325;\n}\n\n\n.toggle_label {\n    position: relative;\n    display: inline-block;\n    width: 60px;\n    height: 30px;\n}\n\n.toggle_input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.toggle_span {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: #E8DFD5;\n    transition: 0.3s;\n    border-radius: 30px;\n}\n\n\n.toggle_span:before {\n    position: absolute;\n    content: \"\";\n    height: 25px;\n    width: 25px;\n    left: 3px;\n    bottom: 2.6px;\n    background-color: #fff;\n    border-radius: 50%;\n    transition: 0.3s;\n}\n\n.toggle_input:checked+.toggle_span {\n    background-color: #48887B;\n}\n\n.toggle_input:checked+.toggle_span:before {\n    transform: translateX(29px);\n}\n\n.ImageCard {\n    width: 92%;\n    display: flex;\n    padding: 5px;\n    background: #FFFFFF;\n    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);\n    border-radius: 5px;\n    margin-left: 60px;\n    margin-top: -20px;\n}\n\n.image-container {\n    flex: 1;\n    padding: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n\n.image-container img {\n    max-width: 100%;\n    max-height: 100%;\n    display: block;\n    border-radius: 5px;\n    object-fit: contain;\n}\n\n.arrows-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 10px; \n  box-sizing: border-box;\n}\n\n.left-arrow {\n  position: absolute;\n  left: 0;\n}\n\n.right-arrow {\n  position: absolute;\n  right: 0;\n}\n.MatchCard {\n    width: 90%;\n    display: flex;\n    padding: 10px;\n    background: #FFFFFF;\n    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);\n    border-radius: 5px;\n    margin-left: 6px;\n}\n\n.RightCard {\n    width: 30%; \n    height: 187px;\n    padding: 10px;\n    background: #FFFFFF;\n    margin: auto;\n    margin-top: 5px; \n    margin-bottom: auto;\n}\n\n.datacard {\n  background-color: white;\n  border-radius: 8px;\n  width: 280px;\n  height: 90px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 20px;\nborder: 2px solid #e0e0e0; /* Example border with a light gray color */\n\n}\n\n.cardheader {\n  /* border-bottom: 1px solid #ccc; */\n  margin-bottom: 10px;\n  /* padding-bottom: 10px; */\n}\n\n.content {\n    margin-top: 0;\n}\n\n.cardheader h4 {\n  margin: 0;\n  font-size: 15px;\n  \n}\n\n.cardline {\n  border: none;\n  border-top: 1px solid #ccc;\n  margin-top: 3px;\n}\n\n.cardicon {\n    width: 12%;\n    \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
